import { render, staticRenderFns } from "./cate_detail.vue?vue&type=template&id=a681bfd6"
import script from "./cate_detail.vue?vue&type=script&lang=js"
export * from "./cate_detail.vue?vue&type=script&lang=js"
import style0 from "./cate_detail.vue?vue&type=style&index=0&id=a681bfd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports